import axios from 'axios'

const env = process.env.VUE_APP_ENV

function reportHandle(options = {}) {
  const logURL = env === 'production' ? 'https://tj2.mini1.cn/miniworld' : 'https://tj2-t.mini1.cn/miniworld'
  const { uin = '', ver = '', country = '', lang = '' } = UserService.getUserInfo() || {}

  const commonParams = {
    ts: Math.floor(new Date().getTime() / 1000),
    uin,
    version: ver,
    country,
    lang,
    platform: '',
    channel: '',
    ip: '__IP__',
    session_id: ''
  }
  // 区分国内海外，不同环境变量env值
  const envMap = {
    development: options.overseas ? 11 : 1,
    test: options.overseas ? 11 : 1,
    beta: 2,
    production: options.overseas ? 10 : 0
  }
  options = Object.assign(commonParams, {
    env: envMap[env], // env  环境标识  "国内" -> 0, "测试" -> 1, "先遣服" -> 2, "海外" -> 10, "海外测试" -> 11
    id: '71001', // 同业务id，生成文件名作用
    product: '71001', // 业务id，如商业化活动，增长相关
    activity: '10001', // 活动场景， 活动ID
    event_type: 'view', // 事件类型，view 浏览；click 点击；enter 输入;
    scene_comp: 'FrontPage' // 场景组件
  }, options)

  const flag = navigator.sendBeacon(logURL, `json3=[${JSON.stringify(options)}]`)
  // return axios({
  //   method: 'post',
  //   url: logURL,
  //   headers: {
  //     'Content-type': 'text/plain'
  //   },
  //   data: `json3=[${JSON.stringify(options)}]`
  // })
}

function makeEvent(product, activity) {
  const _getOptionsHandle = (options, scene_comp, event_type) => reportHandle({ ...options, id: product, product, activity, scene_comp, event_type })

  return {
    view: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'view'),
    click: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'click'),
    enter: (scene_comp, options = {}) => _getOptionsHandle(options, scene_comp, 'enter')
  }
}

export default {
  // 商业化活动
  trade: (activityId) => makeEvent(71000, activityId),
  // 增长相关
  increase: (activityId) => makeEvent(71001, activityId),
  // 市场活动相关
  market: (activityId) => makeEvent(71002, activityId),
  // 平台生态相关
  platform: (activityId) => makeEvent(71003, activityId),
  // IP相关
  ips: (activityId) => makeEvent(71004, activityId),
  // 内容生态相关
  content: (activityId) => makeEvent(71005, activityId)
}

/**
 * 打点服务必填传参：公共参数（如 时间戳ts，环境标识env），场景参数（关于该打点所属业务范围，业务ID--product，活动ID--activity，场景_组件--scene_comp），
 * 事件参数（事件类型event_type，目前包含view--查看，click--点击，enter--输入）
 *
 * 非必填参数：公共参数（如uin迷你号，platform平台ID等），场景参数（无），事件参数（无），自定义参数（v1-v20）
 *
 * 正式环境：https://tj2.mini1.cn/miniworld  测试环境：http://121.37.202.226:8080/miniworld
 * 请求格式：
 *  method: 'post',
    url: logURL,
    headers: {
      'Content-type': 'text/plain'
    },
    data: `json3=[${JSON.stringify(options)}]`
 *
 * 调用方式：
 * webpack中已将Report作为全局变量
 * const options = {} 可以定义任意自定义参数，可为空不传
 * 代码中直接使用如：Report.increase(10001).view('FrontPage', options) // options不是必传参数
 * increase -- 代表所属业务为增长团队业务（拼接后参数product: '71001'）
 *  -- 可选方法有trade（商业化活动71000），increase（增长相关71001），market（市场活动相关71002），platform（平台生态相关71003）,ips（平台生态相关71004），content（内容生态相关）
 * 10001 -- 为活动id（代表activity: '10001'） -- 根据每个活动生成，找产品定义
 * view -- 表浏览事件（代表event_type：'view'）-- 可选方法有view（浏览），click（点击），enter(输入)
 * FrontPage -- 表场景_组件（代表scene_comp: 'FrontPage'） -- 根据每个活动生成的场景，找产品定义
 * 如包含其他参数或了解详情，请查阅： https://mini1.feishu.cn/docs/doccnN4CPSA72sg27vCdAE6Cgwb
 *
 * 注意： 当为海外业务开发时，必须传个自定义参数, 如：const options = {overseas: true}; Report.increase(10001).view('FrontPage', options)
 */
